import App from './App.vue'
import { createPinia } from 'pinia'
import { registerMicroApps, start } from 'qiankun'

import router from './router'
import coordtransform from 'coordtransform'

/** 按需导入只会导入模板中使用的组件，其它地方的组件样式需要手动导入进来 */
import ElementUI from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import '@shared/layout/iconfont-menu/iconfont.js'
import microAppConfig from './microAppConfig'

window.coordtransform = coordtransform

const app = createApp(App)

app.use(router) // 路由
app.use(createPinia()) // 状态管理
app.use(ElementUI, {
  locale: zhCn
})

registerMicroApps(microAppConfig)

router.isReady().then(() => {
  // 启动 qiankun
  start({
    prefetch: [], // 不预加载子应用
    sandbox:{
      strictStyleIsolation: false,
      experimentalStyleIsolation: false
    },
  })
  app.mount('#app')
})
